module.exports = __webpack_public_path__ + "static/media/Campfire.3.c31234e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/Campfire.3.png
// module id = 27
// module chunks = 0